import React, {
  useMemo,
  useState,
} from "react";

import {
  ToastContainer,
} from "react-toastify";

import Footer from "../Home/Footer";

import AuthIcons from "../../hooks/AuthIcons";
import useScrollToTop from "../../hooks/useScrollToTop";

import {
  useUser,
} from "../../contexts/UserContext";

import CateHero from "./components/CateHero";
import CategoryCalculator from "./components/CategoryCalculator";
import CategoryResultCard from "./components/CategoryResultCard";
import CategoriesReference from "./components/CategoriesReference";
import CategoryInfoNotice from "./components/CategoryInfoNotice";

import useJudoCategoryCalculator from "./hooks/useJudoCategoryCalculator";

import {
  getCurrentSeason,
  getSeasonOptions,
} from "./utils/seasonUtils";

export default function MonAppliCatePage() {
  useScrollToTop();

  const { user } = useUser();

  /*
   * Une seule saison pilote toute la page :
   * calculateur + résultat + tableau.
   */
  const [season, setSeason] = useState(
    getCurrentSeason
  );

  const seasonOptions = useMemo(
    () =>
      getSeasonOptions({
        previous: 2,
        next: 2,
      }),
    []
  );

  const {
    formData,
    result,
    hasCalculated,
    updateField,
    calculate,
    reset,
  } = useJudoCategoryCalculator({
    season,
  });

  const scrollToCalculator = () => {
    document
      .getElementById(
        "calculateur-categories"
      )
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-white">
      {!user ? <AuthIcons /> : null}

      <main>
        <CateHero
          season={season}
          onStart={scrollToCalculator}
        />

        <section
          id="calculateur-categories"
          className="relative z-10 scroll-mt-24 py-16 sm:py-20"
        >
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mb-9 text-center">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-orange-600 dark:text-orange-300">
                Calcul simple et immédiat
              </p>

              <h2 className="mt-3 text-3xl font-black text-slate-950 dark:text-white sm:text-4xl">
                Quelle est ma catégorie ?
              </h2>

              <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-slate-500 dark:text-slate-400">
                Sélectionnez votre saison,
                renseignez votre date de
                naissance et ajoutez votre poids
                pour obtenir un résultat complet.
              </p>
            </div>

            <div className="grid gap-7 lg:grid-cols-2 lg:items-start">
              <CategoryCalculator
                season={season}
                seasonOptions={
                  seasonOptions
                }
                formData={formData}
                onSeasonChange={setSeason}
                onFieldChange={updateField}
                onCalculate={calculate}
                onReset={reset}
              />

              <CategoryResultCard
                result={result}
                hasCalculated={
                  hasCalculated
                }
              />
            </div>
          </div>
        </section>

        <section className="pb-16 sm:pb-20">
          <div className="mx-auto max-w-7xl space-y-12 px-4 sm:px-6 lg:px-8">
            <CategoriesReference
              season={season}
            />

            <CategoryInfoNotice />
          </div>
        </section>
      </main>

      <ToastContainer
        position="bottom-right"
        autoClose={3500}
        newestOnTop
        theme="colored"
      />

      <Footer />
    </div>
  );
}